export const productInitList = [
  {
    ext: {
      FILTER: null,
      RECALL: 'RecommendProductRandomRecallV2',
      RANK: 'RecommendProductRankV2'
    },
    categoryId: '124264005',
    offerId: 654428916807,
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01Bn1Ftl1W10mF6KLff_!!2090302727-0-cib.jpg',
    subject: '透视底镂空石英手表满天星镶钻腕表女防水钢带石英轻奢ar1926代发',
    subjectTrans: "Perspective Bottom Hollow Quartz Watch Gypsophila Diamond Watch Women's Waterproof Steel Band Quartz Light Luxury ar1926 Hair",
    minOrderQuantity: 2,
    priceInfo: {
      price: '86.01'
    },
    monthSold: 0,
    tradeScore: '5.0',
    sellerDataInfo: {
      tradeMedalLevel: '1',
      compositeServiceScore: '3.5',
      disputeComplaintScore: '5.0',
      offerExperienceScore: '0.0',
      repeatPurchasePercent: '0.5772741186906236'
    }
  },
  {
    ext: {
      FILTER: null,
      RECALL: 'RecommendProductLongTermInterestsRecallV2',
      RANK: 'RecommendProductRankV2'
    },
    categoryId: '126442003',
    offerId: 781336274289,
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01nyrLpK1nTjJeKR8Ek_!!2215713335091-0-cib.jpg',
    subject: '德训鞋男四季男士运动潮流复古休闲德训鞋平底板鞋小白鞋跨境板鞋',
    subjectTrans: "German Training Shoes Men's Four Seasons Men's Sports Trendy Retro Casual German Training Shoes Flat Sneakers White Shoes Cross-border Sneakers",
    minOrderQuantity: 1,
    priceInfo: {
      price: '169.46'
    },
    monthSold: 338,
    tradeScore: '5.0',
    sellerDataInfo: {
      tradeMedalLevel: '4',
      compositeServiceScore: null,
      disputeComplaintScore: null,
      offerExperienceScore: null,
      repeatPurchasePercent: '0.5448594952230759'
    }
  },
  {
    ext: {
      FILTER: null,
      RECALL: 'RecommendProductRandomRecallV2',
      RANK: 'RecommendProductRankV2'
    },
    categoryId: '1043166',
    offerId: 690816299241,
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01q432Ah1qQvaNTfV6C_!!3917635491-0-cib.jpg',
    subject: '冬日冰川蓝渐变晕染穿戴甲简约甜酷ins风显白假指甲批发nails',
    subjectTrans: 'Winter glacier blue gradient vignette wearing armor simple sweet cool ins Wind white fake nails wholesale nails',
    minOrderQuantity: 1,
    priceInfo: {
      price: '20.87'
    },
    monthSold: 272,
    tradeScore: '5.0',
    sellerDataInfo: {
      tradeMedalLevel: '5',
      compositeServiceScore: '5.0',
      disputeComplaintScore: '4.0',
      offerExperienceScore: '4.0',
      repeatPurchasePercent: '0.7357307915167633'
    }
  },
  {
    ext: {
      FILTER: null,
      RECALL: 'RecommendProductFastMossHotSale4Redis',
      RANK: 'RecommendProductRankV2'
    },
    categoryId: '1039274',
    offerId: 733246398861,
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01o6BUCx1Bs2yOczhjR_!!0-0-cib.jpg',
    subject: '电动清洁刷多功能自动旋转伸缩无线充电长柄硬毛洗地用具',
    subjectTrans: 'Electric cleaning brush multifunctional automatic rotating retractable wireless charging long handle bristle washing appliance',
    minOrderQuantity: 1,
    priceInfo: {
      price: '48.11'
    },
    monthSold: 647,
    tradeScore: '5.0',
    sellerDataInfo: {
      tradeMedalLevel: '4',
      compositeServiceScore: '3.5',
      disputeComplaintScore: '4.0',
      offerExperienceScore: '2.0',
      repeatPurchasePercent: '0.4413020032940596'
    }
  },
  {
    ext: {
      FILTER: null,
      RECALL: 'RecommendProductFastMossHotSale4Redis',
      RANK: 'RecommendProductRankV2'
    },
    categoryId: '1034419',
    offerId: 560701432128,
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01ktLklM1Bs2yNHCpgV_!!0-0-cib.jpg',
    subject: '冬季户外运动加绒保暖手套女防风防寒触屏跑步滑雪骑行手套男批发',
    subjectTrans: 'Winter outdoor sports fleece-lined warm gloves women windproof cold touch screen running ski cycling gloves men wholesale',
    minOrderQuantity: 1,
    priceInfo: {
      price: '51.30'
    },
    monthSold: 713,
    tradeScore: '5.0',
    sellerDataInfo: {
      tradeMedalLevel: '3',
      compositeServiceScore: '5.0',
      disputeComplaintScore: '5.0',
      offerExperienceScore: '4.0',
      repeatPurchasePercent: '0.5704237054148251'
    }
  },
  {
    ext: {
      FILTER: null,
      RECALL: 'RecommendProductRandomRecallV2',
      RANK: 'RecommendProductRankV2'
    },
    categoryId: '1037024',
    offerId: 558110884040,
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/4652054726_1831947616.jpg',
    subject: '春秋季打底裤长裤2025新款仿皮裤加绒加厚外穿小脚女裤子外穿显瘦',
    subjectTrans: "Spring and Autumn leggings trousers 2024 New faux leather pants fleece-lined thickened outer wear skinny women's pants outer wear slimming",
    minOrderQuantity: 1,
    priceInfo: {
      price: '57.29'
    },
    monthSold: 25,
    tradeScore: '5.0',
    sellerDataInfo: {
      tradeMedalLevel: '2',
      compositeServiceScore: '4.0',
      disputeComplaintScore: '4.0',
      offerExperienceScore: '5.0',
      repeatPurchasePercent: '0.5757060557126444'
    }
  },
  {
    ext: {
      FILTER: null,
      RECALL: 'RecommendProductLongTermInterestsRecallV2',
      RANK: 'RecommendProductRankV2'
    },
    categoryId: '126442003',
    offerId: 750773737043,
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01I045D21uWf7RH2wK9_!!2211147486045-0-cib.jpg',
    subject: '帆布男鞋2023新款秋季薄款透气板鞋男士低帮运动平底潮鞋跨境外贸',
    subjectTrans: "Canvas men's shoes 2023 new autumn thin breathable sneakers men's low-top sports flat fashionable shoes cross-border foreign trade",
    minOrderQuantity: 1,
    priceInfo: {
      price: '194.79'
    },
    monthSold: 61,
    tradeScore: '5.0',
    sellerDataInfo: null
  },
  {
    ext: {
      FILTER: null,
      RECALL: 'RecommendProductLongTermInterestsRecallV2',
      RANK: 'RecommendProductRankV2'
    },
    categoryId: '126442003',
    offerId: 724632477059,
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01EYQg991JaCLKtQRH2_!!2811701044-0-cib.jpg',
    subject: '系带学院风运动男鞋大码圆头学生拼色板鞋春秋透气网布休闲鞋跨境',
    subjectTrans: "Lace-up College Style Sports Men's Shoes Large Size Round Head Student Color-matching Sneakers Spring and Autumn Breathable Mesh Casual Shoes Cross-Border",
    minOrderQuantity: 1,
    priceInfo: {
      price: '196.13'
    },
    monthSold: 160,
    tradeScore: '5.0',
    sellerDataInfo: {
      tradeMedalLevel: null,
      compositeServiceScore: null,
      disputeComplaintScore: null,
      offerExperienceScore: null,
      repeatPurchasePercent: '0.4966720428980428'
    }
  },
  {
    ext: {
      FILTER: null,
      RECALL: 'RecommendProductLongTermInterestsRecallV2',
      RANK: 'RecommendProductRankV2'
    },
    categoryId: '126442003',
    offerId: 838675524151,
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01aTd9yd1qYG833UC1z_!!2218032835507-0-cib.jpg',
    subject: '24新外贸面包鞋小白鞋增高溶解鞋广货板鞋真皮软底欧洲站跨境鞋',
    subjectTrans: '2023 foreign trade bread shoes small white shoes increased dissolved shoes wide goods board shoes leather soft bottom European station cross-border shoes',
    minOrderQuantity: 1,
    priceInfo: {
      price: '429.46'
    },
    monthSold: 7,
    tradeScore: '',
    sellerDataInfo: {
      tradeMedalLevel: null,
      compositeServiceScore: '4.0',
      disputeComplaintScore: '4.0',
      offerExperienceScore: '2.0',
      repeatPurchasePercent: '0.45124973332209894'
    }
  },
  {
    ext: {
      FILTER: null,
      RECALL: 'RecommendProductFastMossHotSale4Redis',
      RANK: 'RecommendProductRankV2'
    },
    categoryId: '122522005',
    offerId: 737367898375,
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN010XNM8i1Bs2x7eW47S_!!0-0-cib.jpg',
    subject: '眼镜湿巾擦拭镜片清洁一次性防雾擦镜纸厂家批发擦眼镜专用湿巾纸',
    subjectTrans: 'Glasses cleaning wipes special wipes for lenses disposable professional anti-fog glasses cloth manufacturers wholesale large size',
    minOrderQuantity: 1,
    priceInfo: {
      price: '62.26'
    },
    monthSold: 7977,
    tradeScore: '5.0',
    sellerDataInfo: {
      tradeMedalLevel: '4',
      compositeServiceScore: '4.5',
      disputeComplaintScore: '4.0',
      offerExperienceScore: '3.0',
      repeatPurchasePercent: '0.5917971835948306'
    }
  },
  {
    ext: {
      FILTER: null,
      RECALL: 'RecommendProductFastMossHotSale4Redis',
      RANK: 'RecommendProductRankV2'
    },
    categoryId: '1808',
    offerId: 732883570966,
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01P843Yn1Bs2zv7UDd3_!!0-0-cib.jpg',
    subject: '特大超大扑克牌大纸牌巨大婚庆大型号A4扑克四倍九倍扑克广告婚礼',
    subjectTrans: 'Extra large large playing cards big cards huge wedding big model A4 poker four times nine times poker advertising wedding',
    minOrderQuantity: 1,
    priceInfo: {
      price: '125.98'
    },
    monthSold: 30682,
    tradeScore: '4.9',
    sellerDataInfo: {
      tradeMedalLevel: '4',
      compositeServiceScore: '4.0',
      disputeComplaintScore: '4.0',
      offerExperienceScore: '4.0',
      repeatPurchasePercent: '0.5410986398573302'
    }
  },
  {
    ext: {
      FILTER: null,
      RECALL: 'RecommendProductLongTermInterestsRecallV2',
      RANK: 'RecommendProductRankV2'
    },
    categoryId: '126442003',
    offerId: 743425398855,
    imageUrl: 'https://global-img-cdn.1688.com/img/ibank/O1CN01igxkef22hD9mJAxZY_!!1872887151-0-cib.jpg',
    subject: '跨境外贸48特大码新款百搭男鞋韩版流潮男生中帮板鞋休闲小白鞋子',
    subjectTrans: "Cross-border foreign trade 48 extra large size New versatile men's shoes Korean style trendy men's middle-top sneakers casual white shoes",
    minOrderQuantity: 1,
    priceInfo: {
      price: '170.13'
    },
    monthSold: 299,
    tradeScore: '5.0',
    sellerDataInfo: {
      tradeMedalLevel: null,
      compositeServiceScore: null,
      disputeComplaintScore: null,
      offerExperienceScore: null,
      repeatPurchasePercent: '0.6368939949500079'
    }
  },
  {
    ext: {
      FILTER: null,
      RECALL: 'RecommendProductRandomRecallV2',
      RANK: 'RecommendProductRankV2'
    },
    categoryId: '201310903',
    offerId: 758648473500,
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN010MvaOC22t7QUpirV0_!!3335277177-0-cib.jpg',
    subject: '【P】棉花之翼牛油果60片装大规格深层脸部卸妆巾',
    subjectTrans: '[P] cotton flower wings avocado 60 pieces large size Deep Face cleansing towel',
    minOrderQuantity: 1,
    priceInfo: {
      price: '42.77'
    },
    monthSold: 1422,
    tradeScore: '5.0',
    sellerDataInfo: {
      tradeMedalLevel: '5',
      compositeServiceScore: '5.0',
      disputeComplaintScore: '4.0',
      offerExperienceScore: '4.0',
      repeatPurchasePercent: '0.6427813351072262'
    }
  },
  {
    ext: {
      FILTER: null,
      RECALL: 'RecommendProductFastMossHotSale4Redis',
      RANK: 'RecommendProductRankV2'
    },
    categoryId: '1043504',
    offerId: 741703313955,
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01kUQr1R1Bs2yJAMNuW_!!0-0-cib.jpg',
    subject: '跨境赛琳格不粘杯滋润纹绣剥离式撕拉唇线笔易上色笔唇线唇笔外贸',
    subjectTrans: 'Cross-border Cellinger non-stick cup moisturizing tattoo peeling tear lip liner easy to color pen lip liner foreign trade',
    minOrderQuantity: 3,
    priceInfo: {
      price: '14.90'
    },
    monthSold: 26454,
    tradeScore: '4.9',
    sellerDataInfo: {
      tradeMedalLevel: '2',
      compositeServiceScore: '4.0',
      disputeComplaintScore: '5.0',
      offerExperienceScore: '3.0',
      repeatPurchasePercent: '0.7942969495954175'
    }
  },
  {
    ext: {
      FILTER: null,
      RECALL: 'RecommendProductRandomRecallV2',
      RANK: 'RecommendProductRankV2'
    },
    categoryId: '201156304',
    offerId: 735360045160,
    imageUrl: 'https://global-img-cdn.1688.com/img/ibank/O1CN01dspMu51l7ctfF5A6I_!!2210538694772-0-cib.jpg',
    subject: '亚马逊秋季新款欧美性感气质风连衣裙抹胸长袖网纱敬酒服长款礼服',
    subjectTrans: 'Amazon autumn new European and American sexy elegant style dress tube top long sleeve mesh toast dress long dress',
    minOrderQuantity: 2,
    priceInfo: {
      price: '258.88'
    },
    monthSold: 177,
    tradeScore: '5.0',
    sellerDataInfo: {
      tradeMedalLevel: '2',
      compositeServiceScore: '4.0',
      disputeComplaintScore: '5.0',
      offerExperienceScore: '5.0',
      repeatPurchasePercent: '0.582463431496635'
    }
  },
  {
    ext: {
      FILTER: null,
      RECALL: 'RecommendProductFastMossHotSale4Redis',
      RANK: 'RecommendProductRankV2'
    },
    categoryId: '1037036',
    offerId: 600437863686,
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01vckEae1Bs302imGP0_!!0-0-cib.jpg',
    subject: '新款美背运动内衣女露背健身瑜伽文胸薄款吊带背心上衣夏季D19095',
    subjectTrans: "New Beauty Back Sports Underwear Women's Backless Fitness Yoga Bra Thin Camisole Top Summer D19095",
    minOrderQuantity: 2,
    priceInfo: {
      price: '82.97'
    },
    monthSold: 9224,
    tradeScore: '5.0',
    sellerDataInfo: {
      tradeMedalLevel: '5',
      compositeServiceScore: '5.0',
      disputeComplaintScore: '4.0',
      offerExperienceScore: '4.0',
      repeatPurchasePercent: '0.8616690234708898'
    }
  },
  {
    ext: {
      FILTER: null,
      RECALL: 'RecommendProductLongTermInterestsRecallV2',
      RANK: 'RecommendProductRankV2'
    },
    categoryId: '126442003',
    offerId: 750747893176,
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01smVl6o1uWf7EwyKMF_!!2211147486045-0-cib.jpg',
    subject: '高帮帆布男鞋秋季2023新款冬季板鞋运动增高学生小白潮鞋跨境外贸',
    subjectTrans: "High-top canvas men's shoes Autumn 2023 new winter board shoes sports height increasing student White fashion shoes cross-border foreign trade",
    minOrderQuantity: 1,
    priceInfo: {
      price: '194.79'
    },
    monthSold: 71,
    tradeScore: '5.0',
    sellerDataInfo: {
      tradeMedalLevel: '4',
      compositeServiceScore: '4.0',
      disputeComplaintScore: '4.0',
      offerExperienceScore: '2.0',
      repeatPurchasePercent: '0.5309913244879231'
    }
  },
  {
    ext: {
      FILTER: null,
      RECALL: 'RecommendProductRandomRecallV2',
      RANK: 'RecommendProductRankV2'
    },
    categoryId: '1037009',
    offerId: 777056635014,
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01LAalQC1VWmo8P3wgH_!!6000000002661-0-m_tb_svideo_preimg.jpg',
    subject: '儿童春秋冬季2024新款半高领针织打底衫宝宝上衣内搭保暖洋气百搭',
    subjectTrans: "Children's Spring Autumn and Winter 2024 New Half-turtleneck Knitted Base Shirt Baby's Top with Warm Foreign Style All-match",
    minOrderQuantity: 2,
    priceInfo: {
      price: '74.46'
    },
    monthSold: 0,
    tradeScore: '0.0',
    sellerDataInfo: {
      tradeMedalLevel: '1',
      compositeServiceScore: '4.0',
      disputeComplaintScore: '5.0',
      offerExperienceScore: '5.0',
      repeatPurchasePercent: '0.8020975703172579'
    }
  },
  {
    ext: {
      FILTER: null,
      RECALL: 'RecommendProductFastMossHotSale4Redis',
      RANK: 'RecommendProductRankV2'
    },
    categoryId: '1032098',
    offerId: 749073918731,
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN015HdmOf1Bs2x9cZb96_!!0-0-cib.jpg',
    subject: '夏新车载冰箱8L迷你小型宿舍车家两用式半导体制冷便携一件代发',
    subjectTrans: 'Summer new 8L car refrigerator Mini small dormitory car home dual-use semiconductor refrigeration portable one-piece delivery',
    minOrderQuantity: 1,
    priceInfo: {
      price: '1051.69'
    },
    monthSold: 1272,
    tradeScore: '5.0',
    sellerDataInfo: {
      tradeMedalLevel: '3',
      compositeServiceScore: '3.5',
      disputeComplaintScore: '4.0',
      offerExperienceScore: '2.0',
      repeatPurchasePercent: '0.3700321280540389'
    }
  },
  {
    ext: {
      FILTER: null,
      RECALL: 'RecommendProductRandomRecallV2',
      RANK: 'RecommendProductRankV2'
    },
    categoryId: '1034971',
    offerId: 691148976008,
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01SLa7Fp2JZHv0skaJT_!!2212782539435-0-cib.jpg',
    subject: 'led户外防水草坪草地灯路灯别墅庭院公园花园简约广场园林景观灯',
    subjectTrans: 'led outdoor waterproof lawn grass light street light Villa Courtyard Park garden simple square garden landscape light',
    minOrderQuantity: 1,
    priceInfo: {
      price: '313.86'
    },
    monthSold: 0,
    tradeScore: '5.0',
    sellerDataInfo: {
      tradeMedalLevel: '2',
      compositeServiceScore: '4.0',
      disputeComplaintScore: '5.0',
      offerExperienceScore: '5.0',
      repeatPurchasePercent: '0.5676867148172323'
    }
  },
  {
    ext: {
      FILTER: null,
      RECALL: 'RecommendProductLongTermInterestsRecallV2',
      RANK: 'RecommendProductRankV2'
    },
    categoryId: '126442003',
    offerId: 820103899732,
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01Yaqnp71bZQt4DgFVd_!!2215593123479-0-cib.jpg',
    subject: '外贸专款2024大码板鞋跨境男鞋皮面四季款时尚百搭软底休闲运动鞋',
    subjectTrans: "Foreign trade special fund 2024 plus size board shoes cross-border men's shoes leather four seasons fashion Joker soft bottom casual sneaker",
    minOrderQuantity: 1,
    priceInfo: {
      price: '181.46'
    },
    monthSold: 920,
    tradeScore: '',
    sellerDataInfo: {
      tradeMedalLevel: '3',
      compositeServiceScore: null,
      disputeComplaintScore: null,
      offerExperienceScore: null,
      repeatPurchasePercent: '0.5247157082648233'
    }
  },
  {
    ext: {
      FILTER: null,
      RECALL: 'RecommendProductRandomRecallV2',
      RANK: 'RecommendProductRankV2'
    },
    categoryId: '1031897',
    offerId: 742745637170,
    imageUrl: 'https://global-img-cdn.1688.com/img/ibank/O1CN01BotXUx1TKInvaJSTV_!!2216054072363-0-cib.jpg',
    subject: '跨境欧美秋冬款运动套装风衣套装简约风街头时尚拉链纯色外套男女',
    subjectTrans: 'Cross-border European and American autumn and winter sports suit trench coat suit simple style street fashion zipper solid color coat for men and women',
    minOrderQuantity: 1,
    priceInfo: {
      price: '284.95'
    },
    monthSold: 11,
    tradeScore: '0.0',
    sellerDataInfo: {
      tradeMedalLevel: '2',
      compositeServiceScore: '3.5',
      disputeComplaintScore: '4.0',
      offerExperienceScore: '2.0',
      repeatPurchasePercent: '0.6188678575043081'
    }
  },
  {
    ext: {
      FILTER: null,
      RECALL: 'RecommendProductFastMossHotSale4Redis',
      RANK: 'RecommendProductRankV2'
    },
    categoryId: '1047984',
    offerId: 734075835337,
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01AdSkRi1Bs2zvjCdGp_!!0-0-cib.jpg',
    subject: '新款小刀取暖器家用热暖风机桌面办公室电取暖器跨境欧英美日',
    subjectTrans: 'New knife heater household hot heater desktop office electric heater ',
    minOrderQuantity: 1,
    priceInfo: {
      price: '421.90'
    },
    monthSold: 15,
    tradeScore: '5.0',
    sellerDataInfo: {
      tradeMedalLevel: '3',
      compositeServiceScore: '4.0',
      disputeComplaintScore: '4.0',
      offerExperienceScore: '3.0',
      repeatPurchasePercent: '0.4925402162500196'
    }
  },
  {
    ext: {
      FILTER: null,
      RECALL: 'RecommendProductLongTermInterestsRecallV2',
      RANK: 'RecommendProductRankV2'
    },
    categoryId: '126442003',
    offerId: 923329611652,
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN011Z6jMg1shXRonTShq_!!2219692255798-0-cib.jpg',
    subject: '跨境外贸高端版本驴家板鞋男女款LVTK百搭时尚休闲增高印花运动鞋',
    subjectTrans: 'Cross-border Foreign Trade High-end Version Donkey Shoes for Men and Women LVTK All-match Fashion Casual Height-increasing Printed sneaker',
    minOrderQuantity: 1,
    priceInfo: {
      price: '468.13'
    },
    monthSold: 3,
    tradeScore: '5.0',
    sellerDataInfo: {
      tradeMedalLevel: null,
      compositeServiceScore: null,
      disputeComplaintScore: null,
      offerExperienceScore: null,
      repeatPurchasePercent: '0.33755234113649896'
    }
  },
  {
    ext: {
      FILTER: null,
      RECALL: 'RecommendProductRandomRecallV2',
      RANK: 'RecommendProductRankV2'
    },
    categoryId: '1037010',
    offerId: 842757258933,
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01TkLaft1mtY53eI0LY_!!2215558455012-0-cib.jpg',
    subject: '秋冬儿童纯羊毛衫男女童半高领保暖羊绒毛衣加厚中大小童内搭上衣',
    subjectTrans: "Autumn and Winter Children's Pure Wool Sweater for Boys and Girls Half-high Collar Warm Cashmere Sweater Thickened Inner Top for Children",
    minOrderQuantity: 1,
    priceInfo: {
      price: '163.31'
    },
    monthSold: 3,
    tradeScore: '5.0',
    sellerDataInfo: {
      tradeMedalLevel: '2',
      compositeServiceScore: '4.0',
      disputeComplaintScore: '4.0',
      offerExperienceScore: '2.0',
      repeatPurchasePercent: '0.5068112728790577'
    }
  },
  {
    ext: {
      FILTER: null,
      RECALL: 'RecommendProductRandomRecallV2',
      RANK: 'RecommendProductRankV2'
    },
    categoryId: '123688001',
    offerId: 737947437483,
    imageUrl: 'https://global-img-cdn.1688.com/img/ibank/O1CN010X4py71GfHv5KHttN_!!2214330510649-0-cib.jpg',
    subject: '跨境男装秋冬棒球服夹克潮流卫衣休闲百搭男士宽松外套青少年开衫',
    subjectTrans: "Cross-Border Men's autumn and winter baseball jacket trendy sweater casual versatile men's loose jacket youth cardigan",
    minOrderQuantity: 1,
    priceInfo: {
      price: '165.85'
    },
    monthSold: 0,
    tradeScore: '0.0',
    sellerDataInfo: {
      tradeMedalLevel: '2',
      compositeServiceScore: '4.0',
      disputeComplaintScore: '5.0',
      offerExperienceScore: '5.0',
      repeatPurchasePercent: '0.6211902451225305'
    }
  },
  {
    ext: {
      FILTER: null,
      RECALL: 'RecommendProductLongTermInterestsRecallV2',
      RANK: 'RecommendProductRankV2'
    },
    categoryId: '126442003',
    offerId: 913177073035,
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01vMAj3w23DGkJ1hOKw_!!2208533937221-0-cib.jpg',
    subject: '新品男士小白鞋春秋牛皮板鞋软皮软底透气款跨境情侣运动休闲鞋男',
    subjectTrans: "New Men's White Shoes Spring and Autumn Cowhide Board Shoes Soft Leather Soft Bottom Breathable Cross-border Couple Sports Casual Shoes for Men",
    minOrderQuantity: 1,
    priceInfo: {
      price: '308.13'
    },
    monthSold: 0,
    tradeScore: '',
    sellerDataInfo: null
  },
  {
    ext: {
      FILTER: null,
      RECALL: 'RecommendProductFastMossHotSale4Redis',
      RANK: 'RecommendProductRankV2'
    },
    categoryId: '1031729',
    offerId: 710449746888,
    imageUrl: 'https://global-img-cdn.1688.com/img/ibank/O1CN01IzZaRO1KaUBVCpkea_!!2212718061180-0-cib.jpg',
    subject: '欧式古典抱枕套高级灰黑轻奢艺术靠垫沙发汽车卧室家居装饰靠枕套',
    subjectTrans: 'European-style Classical Pillow Case High-grade Gray and Black Light Luxury Art Cushion Sofa Car Bedroom Home Decoration Pillow Case',
    minOrderQuantity: 2,
    priceInfo: {
      price: '203.35'
    },
    monthSold: 458,
    tradeScore: '4.9',
    sellerDataInfo: {
      tradeMedalLevel: '2',
      compositeServiceScore: '4.0',
      disputeComplaintScore: '3.0',
      offerExperienceScore: '2.0',
      repeatPurchasePercent: '0.8263764163743501'
    }
  },
  {
    ext: {
      FILTER: null,
      RECALL: 'RecommendProductFastMossHotSale4Redis',
      RANK: 'RecommendProductRankV2'
    },
    categoryId: '2028',
    offerId: 678429110410,
    imageUrl: 'https://global-img-cdn.1688.com/img/ibank/O1CN01wfERbz1eS3AEysdxy_!!2200591453869-0-cib.jpg',
    subject: '现货儿童救生衣浮力背心游泳装备浮力衣涉水游泳海边救生马甲',
    subjectTrans: "Spot Children's Life Jacket Buoyancy Vest Swimming Equipment Buoyancy Vest Wading Swimming Seaside Life Vest",
    minOrderQuantity: 1,
    priceInfo: {
      price: '273.65'
    },
    monthSold: 3102,
    tradeScore: '5.0',
    sellerDataInfo: {
      tradeMedalLevel: '3',
      compositeServiceScore: '5.0',
      disputeComplaintScore: '5.0',
      offerExperienceScore: '5.0',
      repeatPurchasePercent: '0.5844423210915185'
    }
  },
  {
    ext: {
      FILTER: null,
      RECALL: 'RecommendProductRandomRecallV2',
      RANK: 'RecommendProductRankV2'
    },
    categoryId: '1037275',
    offerId: 530548784417,
    imageUrl: 'https://global-img-cdn.1688.com/img/ibank/22654003001_344454803.jpg',
    subject: '欧美时尚玻璃仿珍珠项链女款简约打结多层长款毛衣链服装配饰批发',
    subjectTrans: "European and American fashion glass imitation pearl necklace women's simple knotted multi-layer long sweater chain clothing accessories wholesale",
    minOrderQuantity: 2,
    priceInfo: {
      price: '16.30'
    },
    monthSold: 49236,
    tradeScore: '5.0',
    sellerDataInfo: {
      tradeMedalLevel: '3',
      compositeServiceScore: '4.0',
      disputeComplaintScore: '5.0',
      offerExperienceScore: '4.0',
      repeatPurchasePercent: '0.6574101482915908'
    }
  },
  {
    ext: {
      FILTER: null,
      RECALL: 'RecommendProductLongTermInterestsRecallV2',
      RANK: 'RecommendProductRankV2'
    },
    categoryId: '126442003',
    offerId: 835879310498,
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01dwZOrP21UYhQj6Kx2_!!4039616988-0-cib.jpg',
    subject: '跨境爆款大码男士新款休闲运动跑步运动鞋舒适保底轻奢老爹鞋潮鞋',
    subjectTrans: "Cross-border Explosions plus size Men's New Casual Sports Running sneaker Comfortable Sole-guaranteed Light Luxury Trendy Shoes for Torre",
    minOrderQuantity: 2,
    priceInfo: {
      price: '190.82'
    },
    monthSold: 6,
    tradeScore: '',
    sellerDataInfo: {
      tradeMedalLevel: null,
      compositeServiceScore: null,
      disputeComplaintScore: null,
      offerExperienceScore: null,
      repeatPurchasePercent: '0.5247157082648233'
    }
  },
  {
    ext: {
      FILTER: null,
      RECALL: 'RecommendProductFastMossHotSale4Redis',
      RANK: 'RecommendProductRankV2'
    },
    categoryId: '123868002',
    offerId: 844805086714,
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN017pm0zy2Gqk866eEWW_!!2215154269067-0-cib.jpg',
    subject: '独爱极润8g润滑油袋装水溶性人体润滑液拉丝夫妻成人情趣性用品-1',
    subjectTrans: 'Duai extremely moist 8g lubricating oil bag water-soluble human body lubricating liquid wire drawing husband and wife adult sex products -1',
    minOrderQuantity: 1,
    priceInfo: {
      price: '80.87'
    },
    monthSold: 31101,
    tradeScore: '4.8',
    sellerDataInfo: {
      tradeMedalLevel: '3',
      compositeServiceScore: '4.5',
      disputeComplaintScore: '4.0',
      offerExperienceScore: '3.0',
      repeatPurchasePercent: '0.46649849863986703'
    }
  },
  {
    ext: {
      FILTER: null,
      RECALL: 'RecommendProductRandomRecallV2',
      RANK: 'RecommendProductRankV2'
    },
    categoryId: '121778004',
    offerId: 627324517771,
    imageUrl: 'https://global-img-cdn.1688.com/img/ibank/21036594755_2033245681.jpg',
    subject: 'INS陶瓷猫碗猫咪食盆狗盆狗碗饮水碗粮碗保护颈椎宠物用品防打翻',
    subjectTrans: 'INS Ceramic Cat Bowl Cat Food Basin Dog Bowl Drinking Water Bowl Food Bowl Protecting Cervical Spine Pet Supplies Anti-overturning',
    minOrderQuantity: 1,
    priceInfo: {
      price: '69.86'
    },
    monthSold: 1061,
    tradeScore: '5.0',
    sellerDataInfo: {
      tradeMedalLevel: '4',
      compositeServiceScore: '4.5',
      disputeComplaintScore: '4.0',
      offerExperienceScore: '3.0',
      repeatPurchasePercent: '0.6687343629937803'
    }
  },
  {
    ext: {
      FILTER: null,
      RECALL: 'RecommendProductFastMossHotSale4Redis',
      RANK: 'RecommendProductRankV2'
    },
    categoryId: '1031919',
    offerId: 638409245438,
    imageUrl: 'https://global-img-cdn.1688.com/img/ibank/O1CN01U403vX1PTgDur6R58_!!2208066321842-0-cib.jpg',
    subject: '欧美2023夏款短袖t恤女装学生韩版宽松大码女装厂家批发一件代发',
    subjectTrans: "European and American 2023 Summer short-sleeved T-shirt women's clothing student Korean style loose large size women's clothing factory wholesale one-piece delivery",
    minOrderQuantity: 1,
    priceInfo: {
      price: '50.30'
    },
    monthSold: 0,
    tradeScore: '0.0',
    sellerDataInfo: {
      tradeMedalLevel: '4',
      compositeServiceScore: '3.5',
      disputeComplaintScore: '4.0',
      offerExperienceScore: '5.0',
      repeatPurchasePercent: '0.7486880897501125'
    }
  },
  {
    ext: {
      FILTER: null,
      RECALL: 'RecommendProductFastMossHotSale4Redis',
      RANK: 'RecommendProductRankV2'
    },
    categoryId: '1033031',
    offerId: 550155842986,
    imageUrl: 'https://global-img-cdn.1688.com/img/ibank/18941828618_1513547818.jpg',
    subject: '卡通可爱半岛铁盒明信片马口铁收纳盒 首饰饰品发夹储物铁盒子',
    subjectTrans: 'Cartoon cute Peninsula iron box postcard tinplate storage box jewelry jewelry hairpin storage iron box',
    minOrderQuantity: 3,
    priceInfo: {
      price: '106.64'
    },
    monthSold: 194250,
    tradeScore: '5.0',
    sellerDataInfo: {
      tradeMedalLevel: '4',
      compositeServiceScore: '4.0',
      disputeComplaintScore: '5.0',
      offerExperienceScore: '3.0',
      repeatPurchasePercent: '0.7289998029329401'
    }
  },
  {
    ext: {
      FILTER: null,
      RECALL: 'RecommendProductRandomRecallV2',
      RANK: 'RecommendProductRankV2'
    },
    categoryId: '202055601',
    offerId: 816789486465,
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01nRDGX91bKmDAGgAVw_!!2208756683447-0-cib.jpg',
    subject: '原创鎏金指针洛丽塔女衬衣腰封半裙日常可爱Lolita甜美裙子6969',
    subjectTrans: "Original Gold Pointer Lolita Women's Shirt Waist Cover Half Skirt Daily Cute Lolita Sweet Skirt 6969",
    minOrderQuantity: 1,
    priceInfo: {
      price: '485.06'
    },
    monthSold: 2422,
    tradeScore: '5.0',
    sellerDataInfo: {
      tradeMedalLevel: '5',
      compositeServiceScore: '4.0',
      disputeComplaintScore: '5.0',
      offerExperienceScore: '4.0',
      repeatPurchasePercent: '0.6309181899364946'
    }
  },
  {
    ext: {
      FILTER: null,
      RECALL: 'RecommendProductLongTermInterestsRecallV2',
      RANK: 'RecommendProductRankV2'
    },
    categoryId: '126442003',
    offerId: 769711852575,
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01CNy6RF2CMjdzpe89N_!!2849778460-0-cib.jpg',
    subject: '德训鞋男鞋子小白鞋2025春季新款韩版潮流百搭休闲男板鞋跨境批发',
    subjectTrans: "German training shoes men's shoes white shoes 2025 spring new Korean fashion Joker casual men's shoes cross-border wholesale",
    minOrderQuantity: 1,
    priceInfo: {
      price: '170.13'
    },
    monthSold: 382,
    tradeScore: '4.4',
    sellerDataInfo: {
      tradeMedalLevel: '2',
      compositeServiceScore: '3.5',
      disputeComplaintScore: '4.0',
      offerExperienceScore: '2.0',
      repeatPurchasePercent: '0.5328605910566604'
    }
  },
  {
    ext: {
      FILTER: null,
      RECALL: 'RecommendProductLongTermInterestsRecallV2',
      RANK: 'RecommendProductRankV2'
    },
    categoryId: '126442003',
    offerId: 810417713304,
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01M2kaEA1kMuaz0gNQM_!!2206518654670-0-cib.jpg',
    subject: '跨境大码48码鞋子男春季新款男鞋韩版潮流时尚百搭皮面板鞋休闲鞋',
    subjectTrans: "Cross-border plus size 48 yards shoes men's spring new men's shoes Korean trend fashion versatile leather panel shoes casual shoes",
    minOrderQuantity: 1,
    priceInfo: {
      price: '174.79'
    },
    monthSold: 625,
    tradeScore: '',
    sellerDataInfo: {
      tradeMedalLevel: null,
      compositeServiceScore: '4.0',
      disputeComplaintScore: '4.0',
      offerExperienceScore: '3.0',
      repeatPurchasePercent: '0.6042547748224999'
    }
  },
  {
    ext: {
      FILTER: null,
      RECALL: 'RecommendProductRandomRecallV2',
      RANK: 'RecommendProductRankV2'
    },
    categoryId: '1037010',
    offerId: 833578283061,
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01HI3mq51rPO4CEIXwe_!!2216708305623-0-cib.jpg',
    subject: '女童背心裙子加厚保暖秋冬装2024新款儿童装毛毛衣冬季中小童女宝',
    subjectTrans: "Girls Vest Skirt Thickeneded Warm Autumn and Winter Clothing 2024 New Kidsren's Clothing Wool Sweater Winter Small and Medium-Sized Girls",
    minOrderQuantity: 1,
    priceInfo: {
      price: '109.98'
    },
    monthSold: 0,
    tradeScore: '5.0',
    sellerDataInfo: {
      tradeMedalLevel: '2',
      compositeServiceScore: '4.0',
      disputeComplaintScore: '4.0',
      offerExperienceScore: '5.0',
      repeatPurchasePercent: '0.7316097185846538'
    }
  },
  {
    ext: {
      FILTER: null,
      RECALL: 'RecommendProductFastMossHotSale4Redis',
      RANK: 'RecommendProductRankV2'
    },
    categoryId: '122382010',
    offerId: 582156271908,
    imageUrl: 'https://global-img-cdn.1688.com/img/ibank/14606352820_1915518611.jpg',
    subject: '安得雅70克加厚洗衣袋粗细网袋洗衣机家用衣服内衣文胸护洗袋批发',
    subjectTrans: 'Andjah 70g Thickened Laundry Bag Thickness and Fine Mesh Bag Washing Machine Household Clothes Underwear Bra Washing Bag Wholesale',
    minOrderQuantity: 1,
    priceInfo: {
      price: '54.35'
    },
    monthSold: 168043,
    tradeScore: '5.0',
    sellerDataInfo: {
      tradeMedalLevel: '4',
      compositeServiceScore: '5.0',
      disputeComplaintScore: '4.0',
      offerExperienceScore: '4.0',
      repeatPurchasePercent: '0.7019839480977165'
    }
  },
  {
    ext: {
      FILTER: null,
      RECALL: 'RecommendProductLongTermInterestsRecallV2',
      RANK: 'RecommendProductRankV2'
    },
    categoryId: '126442003',
    offerId: 795013495497,
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01EPoheS2F19rM2bxde_!!2216380898819-0-cib.jpg',
    subject: '男士休闲一脚蹬飞织网布防滑耐磨舒适透气百搭韩版跨境外贸一代发',
    subjectTrans: "Men's Casual Slip-on Fly-woven Mesh Non-slip Wear-resistant Comfortable Breathable All-match Korean-style Cross-border Foreign Trade Generation Hair",
    minOrderQuantity: 1,
    priceInfo: {
      price: '154.78'
    },
    monthSold: 425,
    tradeScore: '',
    sellerDataInfo: {
      tradeMedalLevel: '2',
      compositeServiceScore: null,
      disputeComplaintScore: null,
      offerExperienceScore: null,
      repeatPurchasePercent: '0.6301738806556615'
    }
  },
  {
    ext: {
      FILTER: null,
      RECALL: 'RecommendProductFastMossHotSale4Redis',
      RANK: 'RecommendProductRankV2'
    },
    categoryId: '122986002',
    offerId: 565152185075,
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01fQk5Ko1Bs2zs6u8op_!!0-0-cib.jpg',
    subject: '厂家批发泰迪熊小熊抱抱熊公仔毛绒玩具熊抱枕可爱布娃娃婚庆礼品',
    subjectTrans: 'teddy bear bear hug bear doll plush toy bear pillow cute rag doll wedding gift',
    minOrderQuantity: 1,
    priceInfo: {
      price: '181.59'
    },
    monthSold: 12981,
    tradeScore: '4.9',
    sellerDataInfo: {
      tradeMedalLevel: '3',
      compositeServiceScore: '4.5',
      disputeComplaintScore: '4.0',
      offerExperienceScore: '4.0',
      repeatPurchasePercent: '0.6341983462274724'
    }
  },
  {
    ext: {
      FILTER: null,
      RECALL: 'RecommendProductLongTermInterestsRecallV2',
      RANK: 'RecommendProductRankV2'
    },
    categoryId: '126442003',
    offerId: 880550271402,
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01WnxIB21TAE9ulSvYw_!!2217664492341-0-cib.jpg',
    subject: '跨境新款潮流男鞋文艺风板鞋时尚休闲鞋',
    subjectTrans: "Cross-Border New Trendy Men's Shoes, Artistic Style Sneakers, Fashionable Casual Shoes",
    minOrderQuantity: 1,
    priceInfo: {
      price: '216.82'
    },
    monthSold: 0,
    tradeScore: '',
    sellerDataInfo: {
      tradeMedalLevel: '5',
      compositeServiceScore: '3.5',
      disputeComplaintScore: '4.0',
      offerExperienceScore: '2.0',
      repeatPurchasePercent: '0.47655934585173443'
    }
  },
  {
    ext: {
      FILTER: null,
      RECALL: 'RecommendProductRandomRecallV2',
      RANK: 'RecommendProductRankV2'
    },
    categoryId: '1037275',
    offerId: 828723527296,
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01lV1XHD1b7x8NgR5Qb_!!2213065633419-0-cib.jpg',
    subject: '方珍珠链不锈钢男士项链DIY配件潮流18K金钛钢饰品跨境黑色挂链',
    subjectTrans: "Square Pearl Chain Stainless Steel Men's Necklace DIY Accessories Trendy 18K Gold Titanium Steel Jewelry Cross Border Black Hanging Chain",
    minOrderQuantity: 50,
    priceInfo: {
      price: '5.98'
    },
    monthSold: 22988,
    tradeScore: '5.0',
    sellerDataInfo: {
      tradeMedalLevel: '2',
      compositeServiceScore: '3.0',
      disputeComplaintScore: '5.0',
      offerExperienceScore: '0.0',
      repeatPurchasePercent: '0.7816522711130951'
    }
  },
  {
    ext: {
      FILTER: null,
      RECALL: 'RecommendProductLongTermInterestsRecallV2',
      RANK: 'RecommendProductRankV2'
    },
    categoryId: '126442003',
    offerId: 843187536190,
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01bXju3i2LUMr8AH6EM_!!2214959989695-0-cib.jpg',
    subject: '跨境秋季新款百搭潮流男士一脚蹬休闲皮鞋男款手工上线防滑板鞋潮',
    subjectTrans: "Cross-border Autumn New All-match Trendy Men's Slip-on Casual Leather Shoes Men's Handmade Online Non-slip Sneakers Trendy",
    minOrderQuantity: 1,
    priceInfo: {
      price: '237.46'
    },
    monthSold: 1,
    tradeScore: '',
    sellerDataInfo: null
  },
  {
    ext: {
      FILTER: null,
      RECALL: 'RecommendProductRandomRecallV2',
      RANK: 'RecommendProductRankV2'
    },
    categoryId: '1031871',
    offerId: 772420588580,
    imageUrl: 'https://global-img-cdn.1688.com/img/ibank/O1CN01pedw5U28IpoPIlhCl_!!2216775517910-0-cib.jpg',
    subject: '2024欧美跨境亚马逊爆款水洗牛仔显瘦直筒长裤复古做旧高腰牛仔裤',
    subjectTrans: '2024 European and American cross-border Amazon popular washed Denim slimming straight trousers retro distressed high waist jeans',
    minOrderQuantity: 1,
    priceInfo: {
      price: '146.35'
    },
    monthSold: 44,
    tradeScore: '5.0',
    sellerDataInfo: {
      tradeMedalLevel: '2',
      compositeServiceScore: '3.5',
      disputeComplaintScore: '5.0',
      offerExperienceScore: '4.0',
      repeatPurchasePercent: '0.45627526098011534'
    }
  },
  {
    ext: {
      FILTER: null,
      RECALL: 'RecommendProductFastMossHotSale4Redis',
      RANK: 'RecommendProductRankV2'
    },
    categoryId: '121886002',
    offerId: 554875892846,
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN01OXfTuX1Bs2yMHO7ex_!!0-0-cib.jpg',
    subject: '户外运动装备骑行背包多功能专用水袋2升结实耐用不漏水袋',
    subjectTrans: 'Outdoor Sports Equipment Riding Backpack Multifunctional Special Water Bag 2 Liters Strong and Durable Water-tight Bag',
    minOrderQuantity: 1,
    priceInfo: {
      price: '192.63'
    },
    monthSold: 7990,
    tradeScore: '5.0',
    sellerDataInfo: {
      tradeMedalLevel: '4',
      compositeServiceScore: '4.0',
      disputeComplaintScore: '4.0',
      offerExperienceScore: '4.0',
      repeatPurchasePercent: '0.6164623408286154'
    }
  },
  {
    ext: {
      FILTER: null,
      RECALL: 'RecommendProductRandomRecallV2',
      RANK: 'RecommendProductRankV2'
    },
    categoryId: '1045532',
    offerId: 588740327440,
    imageUrl: 'https://global-img-cdn.1688.com/img/ibank/10666777954_303715330.jpg',
    subject: '批发水晶发光指尖陀螺电镀掌上旋转塑料手指陀螺跨境地摊爆款玩具',
    subjectTrans: 'Wholesale Crystal luminous fingertip gyro electroplating Palm rotating plastic finger gyro cross-border stall hot toys',
    minOrderQuantity: 3,
    priceInfo: {
      price: '32.68'
    },
    monthSold: 8592,
    tradeScore: '4.6',
    sellerDataInfo: {
      tradeMedalLevel: '3',
      compositeServiceScore: '5.0',
      disputeComplaintScore: '4.0',
      offerExperienceScore: '5.0',
      repeatPurchasePercent: '0.7091591676314868'
    }
  },
  {
    ext: {
      FILTER: null,
      RECALL: 'RecommendProductLongTermInterestsRecallV2',
      RANK: 'RecommendProductRankV2'
    },
    categoryId: '126442003',
    offerId: 826094629535,
    imageUrl: 'https://cbu01.alicdn.com/img/ibank/O1CN0141xHOb22hDFTgJFGM_!!1872887151-0-cib.jpg',
    subject: '跨境2024新款男鞋时尚透气夏季新款舒适时尚潮流潮鞋板鞋百搭休闲',
    subjectTrans: "Cross-Border 2024 New Men's Shoes, Fashionable and Breathable, Summer New Style, Comfortable, Fashionable and Trendy Shoes, Sneakers, Versatile and Casual",
    minOrderQuantity: 1,
    priceInfo: {
      price: '176.13'
    },
    monthSold: 43,
    tradeScore: '',
    sellerDataInfo: {
      tradeMedalLevel: null,
      compositeServiceScore: null,
      disputeComplaintScore: null,
      offerExperienceScore: null,
      repeatPurchasePercent: '0.6368939949500079'
    }
  },
  {
    ext: {
      FILTER: null,
      RECALL: 'RecommendProductRandomRecallV2',
      RANK: 'RecommendProductRankV2'
    },
    categoryId: '1037003',
    offerId: 713508652547,
    imageUrl: 'https://global-img-cdn.1688.com/img/ibank/11327076927_1794220726.jpg',
    subject: '5个装哈衣爬服延长片宝宝包屁连身衣加长布垫棉跨境 extender',
    subjectTrans: '5 Pack Hakai Climbing Suit Extension Pieces Baby Bag Fart jumpsuit Lengthened Cloth Pad Cotton Cross-border extender',
    minOrderQuantity: 1,
    priceInfo: {
      price: '95.79'
    },
    monthSold: 9166,
    tradeScore: '4.7',
    sellerDataInfo: {
      tradeMedalLevel: '3',
      compositeServiceScore: '4.0',
      disputeComplaintScore: '4.0',
      offerExperienceScore: '5.0',
      repeatPurchasePercent: '0.7447744788233922'
    }
  }
]
